import { Chip, Tooltip } from "@mui/material";
import { useStudentLabelPalette } from "../hooks/useStudentLabelPalette";
import { DrivingSchoolLabel } from "../providers/drivingSchoolsProvider";

export function Label({ label, hideTooltip = false }: { label: DrivingSchoolLabel; hideTooltip?: boolean }) {
  const studentLabelColors = useStudentLabelPalette()[label.color];
  return (
    <Tooltip title={hideTooltip ? null : label.description} arrow placement="bottom">
      <Chip
        label={label.name}
        variant="filled"
        size="small"
        sx={{
          backgroundColor: studentLabelColors.background,
          color: studentLabelColors.text,
          fontWeight: "500",
          fontSize: "10px",
          height: "20px",
        }}
      />
    </Tooltip>
  );
}
